<template>
  <span class="status-label" :class="`status-label--${item.value}`">
    {{ item.text }}
  </span>
</template>

<script>
export default {
  props: ['item'],
};
</script>

<style scoped lang="scss">
.status-label {
  display: inline-block;
  background: #e0effd;
  color: #3379ba;
  padding: 0.3rem 0.5rem;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
  white-space: nowrap;
  height: 100%;

  &--pending,
  &--refund_pending{
    background: #feebd9;
    color: #ac6b2d;
  }

  &--created,
  &--approved,
  &--scheduled {
    background: #bcfbdb;
    color: #1d7e1c;
  }

  &--rejected,
  &--removed,
  &--finished,
  &--delayed,
  &--refund_finished {
    background: #fee8f4;
    color: #d73134;
  }

  &--stopped,
  &--refund_cancelled,
  &--cancelled {
    background: #fee8f4;
    color: #d33386;
  }

  &--expired,
  &--inactivated {
    background: #ebeef0;
    color: #96a1ad;
  }

  &--draft {
    background: #D8EEE7;
    color: #538D82;
  }

}
</style>
